import type { ReactNode } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { ErrorProvider } from "~components/ErrorHandler/ErrorProvider";
import { PermissionOperations, PermissionNames } from "~enums/permissions";
import { useUserPermissions } from "~context/UserPermissionsContext";
import { AccessDeniedPage } from "~pages/ErrorPages";

interface AuthGuardProps {
  children: ReactNode;
  permissionKey?: PermissionNames;
}

const AuthGuard = ({ children, permissionKey }: AuthGuardProps) => {
  const { isLoadingPermissions, hasPermission, hasOrganizationAccess } = useUserPermissions();

  if (isLoadingPermissions) {
    return (
      <div className="loading-full-screen">
        <LoadingOutlined style={{ fontSize: 44 }} spin />
      </div>
    );
  }

  if (hasOrganizationAccess && (!permissionKey || hasPermission(permissionKey, PermissionOperations.READ))) {
    return <ErrorProvider>{children}</ErrorProvider>;
  }
  return <AccessDeniedPage />;
};

export default AuthGuard;
